import Vue from 'vue'
import Axios from '@/config/axios'

export default {
  namespaced: true,
  state: {
    defaultCountry: null,
    states: {},
    statesPerCountry: {},
    countries: {},
    countriesLoadedCallbacks: [],
    selectDataIsLoaded: { state_id: {}, country_id: false },
    selectDataIsLoading: { state_id: false, country_id: false },
  },

  mutations: {
    setState(state, payload) {
      state[payload[0]] = payload[1]
    },

    setDefaultCountry(state, countryId) {
      state.defaultCountry = countryId
    },

    pushToCountriesLoadedCallbacks(state, fn) {
      state.countriesLoadedCallbacks.push(fn)
    },

    setSelectDataIsLoading(state, payload) {
      Vue.set(state.selectDataIsLoading, payload[0], payload[1])
    },

    setStatesPerCountry(state, payload) {
      Vue.set(state.statesPerCountry, payload[0], payload[1])
    },

    setSelectStateIsLoaded(state, countryId) {
      Vue.set(state.selectDataIsLoaded.state_id, countryId, true)
    },

    setSelectCountryIsLoaded(state) {
      Vue.set(state.selectDataIsLoaded, 'country_id', true)
    },

    setCountryHasStates(state, payload) {
      Vue.set(state.countries[payload[0]], 'has_states', payload[1])
    },
  },

  actions: {
    populateAddressSelectMenus({ dispatch }, countryId) {
      dispatch('loadAllStatesOfCountryOnce', countryId)
      dispatch('loadAllCountriesOnce')
    },

    loadAllStatesOfCountryOnce({ commit, dispatch, state }, countryId) {
      const proceed =
        !state.selectDataIsLoaded.state_id[countryId] &&
        !state.selectDataIsLoading.state_id &&
        countryId
      if (!proceed) {
        return
      }
      commit('setSelectDataIsLoading', ['state_id', true])

      Axios.get(`/addresses/states?country_id=${countryId}`)
        .then(({ data }) => {
          dispatch('onSuccessOfStatesLoading', { data, countryId })
        })
        .finally(() => commit('setSelectDataIsLoading', ['state_id', false]))
    },

    onSuccessOfStatesLoading({ commit, dispatch, state }, { data, countryId }) {
      const stateKeys = Object.keys(data)
      const hasStates = !!stateKeys.length

      if (!hasStates || (stateKeys[0] && data[stateKeys[0]].name)) {
        const statesOfThisCountry = []
        stateKeys.forEach(stateId => statesOfThisCountry.push(stateId))
        commit('setStatesPerCountry', [countryId, statesOfThisCountry])
        commit('setState', ['states', { ...state.states, ...data }])
        commit('setSelectStateIsLoaded', countryId)

        dispatch('onceCountriesAreLoaded', () => {
          commit('setCountryHasStates', [countryId, hasStates])
        })
      }
    },

    loadAllCountriesOnce({ commit, dispatch, state }) {
      if (state.selectDataIsLoaded.country_id) {
        return
      }
      commit('setSelectDataIsLoading', ['country_id', true])

      Axios.get('/addresses/countries')
        .then(({ data }) => {
          const keys = Object.keys(data)

          if (keys[0] && data[keys[0]].name) {
            commit('setState', ['countries', { ...data, ...state.countries }])
            commit('setSelectCountryIsLoaded')
            dispatch('onceCountriesAreLoaded')
          }
        })
        .finally(() => commit('setSelectDataIsLoading', ['country_id', false]))
    },

    onceCountriesAreLoaded({ commit, state }, callback) {
      if (callback) {
        commit('pushToCountriesLoadedCallbacks', callback)
      }
      if (state.selectDataIsLoaded.country_id) {
        state.countriesLoadedCallbacks.forEach(fn => fn())
        commit('setState', ['countriesLoadedCallbacks', []])
      }
    },
  },
}
